<mat-card appearance="outlined">
  <mat-card-content>

    <query-builder [config]="config" [emptyMessage]="emptyMessage | translate" [formControl]="query" [operatorMap]="operatorMap">

      <ng-container *querySwitchGroup="let ruleset; let onChange = onChange">
        <mat-radio-group (ngModelChange)="ruleset.condition = $event; onChange($event)" *ngIf="ruleset"
                         [ngModel]="ruleset.condition">
          <mat-radio-button [style.padding.px]="10" value="and">{{ 'QUERY_BUILDER.and' | translate }}</mat-radio-button>
          <mat-radio-button [style.padding.px]="10" value="or">{{ 'QUERY_BUILDER.or' | translate }}</mat-radio-button>
        </mat-radio-group>
      </ng-container>

      <ng-container
        *queryButtonGroup="let ruleset; let addRule = addRule; let addRuleSet = addRuleSet; let removeRuleSet = removeRuleSet">
        <button (click)="addRule()" color="primary" mat-icon-button type="button">
          <mat-icon>add</mat-icon>
        </button>
        <button (click)="addRuleSet()" *ngIf="addRuleSet" color="primary" mat-icon-button type="button">
          <mat-icon>add_circle_outline</mat-icon>
        </button>
        <button (click)="removeRuleSet()" *ngIf="removeRuleSet" color="warn" mat-icon-button type="button">
          <mat-icon>remove_circle_outline</mat-icon>
        </button>
      </ng-container>

      <ng-container *queryRemoveButton="let rule; let removeRule=removeRule">
        <button (click)="removeRule(rule)" color="warn" mat-icon-button type="button">
          <mat-icon>remove</mat-icon>
        </button>
      </ng-container>

      <ng-container *queryField="let rule; let fields = fields; let onChange = onChange; let getFields = getFields">
        <mat-form-field>
          <mat-select (ngModelChange)="rule.field = $event; onChange($event, rule)" [ngModel]="rule.field">
            <app-select-search></app-select-search>
            <mat-option *ngFor="let field of getFields()" [value]="field.value">
              {{ field.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-container *queryOperator="let rule; let operators = operators; let onChange = onChange">
        <mat-form-field class="query-operator">
          <mat-select (ngModelChange)="rule.operator = $event; onChange(rule)" [ngModel]="rule.operator">
            <mat-option *ngFor="let operator of operators" [value]="operator">
              {{ operatorLabels[operator] ? (operatorLabels[operator] | translate) : operator }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <!-- Задание значения для entity типа -->
      <ng-container *queryInput="let rule; let options = options; type: 'entity'; let onChange = onChange">
        <ng-container *ngIf="['in', 'not in'].includes(rule.operator) else regular">
          <app-multiple-entity-query-input [onChange]="onChange" [options]="options" [rule]="rule" class="query-input">
          </app-multiple-entity-query-input>
        </ng-container>
        <ng-template #regular>
          <app-single-entity-query-input [onChange]="onChange" [options]="options" [rule]="rule" class="query-input">
          </app-single-entity-query-input>
        </ng-template>
      </ng-container>

      <!-- Задание значения для number типа -->
      <ng-container *queryInput="let rule; let field = field; type: 'number'; let onChange = onChange">
        <ng-container *ngIf="['in', 'not in'].includes(rule.operator) else regular">
          <app-chip-number-query-input [onChange]="onChange" [rule]="rule" class="query-input">
          </app-chip-number-query-input>
        </ng-container>
        <ng-template #regular>
          <app-simple-number-query-input [onChange]="onChange" [rule]="rule" class="query-input">
          </app-simple-number-query-input>
        </ng-template>
      </ng-container>

      <!-- Задание значения для string типа -->
      <ng-container *queryInput="let rule; type: 'string'; let onChange = onChange">
        <ng-container *ngIf="['in', 'not in'].includes(rule.operator) else regular">
          <app-chip-string-query-input [onChange]="onChange" [rule]="rule" class="query-input">
          </app-chip-string-query-input>
        </ng-container>
        <ng-template #regular>
          <app-simple-string-query-input [onChange]="onChange" [rule]="rule" class="query-input">
          </app-simple-string-query-input>
        </ng-template>
      </ng-container>

      <!--Задание значения для типа datetime-->
      <ng-container *queryInput="let rule; let options = options; type: 'datetime'; let onChange = onChange">
        <app-datetime-query-input [onChange]="onChange" [rule]="rule"></app-datetime-query-input>
      </ng-container>

    </query-builder>
  </mat-card-content>
</mat-card>
